/* /src/components/auth/silentRenew.js */

import React from "react";

export const SilentRenew = () => (
    <span>loading</span>
);